import { useEffect, useMemo } from "react";
import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { WizardStep } from "src/sections/wizard/wizard-step";
import { useDispatch, useSelector } from "src/store";
import { thunks as settingsThunks } from "src/thunks/settings";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import type { Page as PageType } from "src/types/page";
import { SectionFormType, StrategyStepConfiguration } from "src/types/strategy";
import { SECTION_KEYS } from "src/consts";
import { thunks } from "src/thunks/strategy-wizard";
import { BrandDetails } from "src/sections/strategy/brand-details";
import { thunks as strategyThunks } from "src/thunks/strategy-wizard";
import { useStrategySteps } from "./use-strategy-steps";
import { Finish } from "src/sections/strategy/finish";

const Page: PageType = () => {
  usePageView();
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { strategyId } = useParams();

  const configSteps = useStrategySteps();
  const steps = useSelector((state) => state.strategyWizard.steps);

  useEffect(() => {
    async function initSteps() {
      if (strategyId) {
        await dispatch(thunks.getStrategySteps(configSteps));
        await dispatch(settingsThunks.setStrategyId(strategyId));
        await dispatch(strategyThunks.setCurrentStep(2));
      } else {
        router.push(paths.index);
      }
    }
    initSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [strategyId]);

  if (!steps.length) {
    return null;
  }

  return (
    <>
      <Seo title="Ідеї для блогів" />
      <Finish />
    </>
  );
};

export default Page;
